<template>
  <v-snackbar top :multi-line="true" dark v-model="snackbars" :timeout="1500">
    <div class="text-center">
      <div>
        <v-icon class = "iconic" :color="snackbar.snackbarSuccess ? '#fff' : 'red'" size="40">{{
          snackbar.snackbarSuccess ? "mdi-check-bold" : "mdi-close-thick"
        }}</v-icon>
      </div>

      <h4 class="ml-2 body-1">{{ snackbar.snackbarMsg }}</h4>
    </div>
  </v-snackbar>
</template>
   
  <script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    snackbars: false,
  }),
  computed: {
    ...mapGetters({
      snackbar: "snackbar",
    }),
  },
  watch: {
    snackbar: {
      handler() {        
        this.snackbars = this.snackbar.snackbar;
      },
      deep: true,
    },
  },
  methods: {
    showSuccessSnackbar() {
      let snackbar = {
        snackbarSuccess: false,
        snackbarMsg: "",
        snackbar: true,
      };
      this.setSnackbar(snackbar);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
:deep(.v-snack__wrapper) {
  min-width: auto;
  margin-top: 70px;
  background-color: rgba($primary, 0.7);
  margin-right: 8px !important;
  color: white; 
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.iconic {
  animation: rotate 0.6s ease-in-out forwards;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>